//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'feedback')
    ])
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages
    }),
  },
  components: {
    feedback: () => import('~/components/forms/feedback.vue')
  },
  head() {
    return {
      title: this.pages.feedback && this.pages.feedback.seo ? this.pages.feedback.seo.title : 'Feedback | Info | Meiden van Holland',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.feedback && this.pages.feedback.seo ? this.pages.feedback.seo.title : 'Feedback | Info | Meiden van Holland' },
        { hid: 'og:title', name: 'og:title', content: this.pages.feedback && this.pages.feedback.seo ? this.pages.feedback.seo.title : 'Feedback | Info | Meiden van Holland' },
        { hid: 'description', name: 'description', content: this.pages.feedback && this.pages.feedback.seo ? this.pages.feedback.seo.description : 'De website van Meiden van Holland wordt regelmatig geüpdate en verbeterd. We horen graag wat jij ervan vindt. Laat het ons hier weten.'},
        { hid: 'og:description', name: 'og:description', content: this.pages.feedback && this.pages.feedback.seo ? this.pages.feedback.seo.description : 'De website van Meiden van Holland wordt regelmatig geüpdate en verbeterd. We horen graag wat jij ervan vindt. Laat het ons hier weten.' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/feedback' },
        { hid: 'keywords', name: 'keywords', content: this.pages.over ? this.pages.feedback.seo.keywords : 'Feedback, mening, wat vind jij' },
      ]
    }
  },
  data() {
    return {
    }
  },
}
